import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { EventDetail } from '../../../qrcode/models/qrcode';
import { EventLoadType } from 'src/app/shared/enums/get-event.enum';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private readonly event = 'eventDetail';
  private readonly eventDetailSubject = new BehaviorSubject<EventDetail | null>(null);

  /** Emite o detalhe atual e sempre que `setEventDetail` / `removeEventDetail` atualizarem o armazenamento. */
  readonly eventDetail$: Observable<EventDetail | null> = this.eventDetailSubject.asObservable();

  constructor(
    private readonly http: HttpClient,
    private readonly storageService: StorageService,
  ) {
    this.eventDetailSubject.next(this.readEventDetailFromStorage());
  }

  getEventById(id: string, loadType: EventLoadType = EventLoadType.ActiveLots): Observable<EventDetail> {
    return this.http.get<EventDetail>(
      `${environment.BaseURL}${environment.MicroService.Events}/${id}?loadType=${loadType}`,
    );
  }

  getEventDetail(): EventDetail | null {
    return this.readEventDetailFromStorage();
  }

  removeEventDetail(): void {
    this.storageService.removeItem(this.event);
    this.eventDetailSubject.next(null);
  }

  setEventDetail(event: EventDetail | Record<string, unknown> | string): void {
    const value = typeof event === 'string' ? event : JSON.stringify(event);
    this.storageService.setItem(this.event, value);
    const parsed =
      typeof event === 'string' ? (JSON.parse(event) as EventDetail) : (event as EventDetail);
    this.eventDetailSubject.next(parsed);
  }

  private readEventDetailFromStorage(): EventDetail | null {
    const eventValue = this.storageService.getItem(this.event);

    if (!eventValue) {
      return null;
    }

    try {
      return JSON.parse(eventValue) as EventDetail;
    } catch (error) {
      console.error('Erro ao ler detalhes do evento do armazenamento local.', error);
      return null;
    }
  }
}
